import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var DiHomePageService = /** @class */ (function () {
    function DiHomePageService(http, bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
        this.URI = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.diNewsListApi = ConstantValues.userManagementApiUrl.getDiNewsList;
        this.reteamListApi = ConstantValues.userManagementApiUrl.getReteamList;
        this.naacListApi = ConstantValues.userManagementApiUrl.getNaacList;
        this.diMasterListApi = ConstantValues.userManagementApiUrl.getDiMasterList;
        this.getDiResouceListApi = ConstantValues.userManagementApiUrl.getDiResouceList;
    }
    /** For service call to get bpg news list
     * @class DiHomePageService
     * @method getDiNewsList
     * @param landingData
     * @returns Observable
     **/
    DiHomePageService.prototype.getDiNewsList = function (landingData) {
        return this.http.post(this.URI + this.diNewsListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get bpg news list
      * @class DiHomePageService
      * @method getEngagementTeamList
      * @param landingData
      * @returns Observable
      **/
    DiHomePageService.prototype.getEngagementTeamList = function (landingData) {
        return this.http.post(this.URI + this.reteamListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get bpg news list
      * @class DiHomePageService
      * @method getNaacList
      * @param landingData
      * @returns Observable
      **/
    DiHomePageService.prototype.getNaacList = function (landingData) {
        return this.http.post(this.URI + this.naacListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get  di master List
       * @class DiHomePageService
       * @method getDiMasterList
       * @param landingData
       * @returns Observable
       **/
    DiHomePageService.prototype.getDiMasterList = function (landingData) {
        return this.http.post(this.URI + this.diMasterListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get bpg di resource List
   * @class DiHomePageService
   * @method getDiResouceList
   * @param landingData
   * @returns Observable
   **/
    DiHomePageService.prototype.getDiResouceList = function (landingData) {
        return this.http.post(this.URI + this.getDiResouceListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    DiHomePageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DiHomePageService_Factory() { return new DiHomePageService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: DiHomePageService, providedIn: "root" });
    return DiHomePageService;
}());
export { DiHomePageService };
